import React, { useRef, useLayoutEffect } from 'react';
import {
    getTaskDescriptionHtmlForDisplay,
    syncCheckboxAttributesToHtml,
} from '../../../utils/task_description_html';

/**
 * Vista de solo lectura de la descripción de tarea (HTML enriquecido + checklists).
 */
const TaskDescriptionView = ({
    html,
    className = 'task-description-view',
    editableCheckboxes = false,
    onCheckboxChange,
}) => {
    const viewRef = useRef(null);

    useLayoutEffect(() => {
        const el = viewRef.current;
        if (!el || !editableCheckboxes || !onCheckboxChange) return;

        const handler = (e) => {
            if (!e.target.matches('input[type="checkbox"]') || !el.contains(e.target)) return;
            e.preventDefault();
            e.target.checked = !e.target.checked;
            syncCheckboxAttributesToHtml(el);
            onCheckboxChange(el.innerHTML);
        };

        el.addEventListener('click', handler, true);
        return () => el.removeEventListener('click', handler, true);
    }, [html, editableCheckboxes, onCheckboxChange]);

  if (!html || !String(html).trim()) {
        return null;
    }

    return (
        <div
            ref={viewRef}
            className={className}
            style={{ cursor: editableCheckboxes ? 'default' : undefined }}
            dangerouslySetInnerHTML={{ __html: getTaskDescriptionHtmlForDisplay(html) }}
            role="document"
            aria-label="Descripción de la tarea"
        />
    );
};

export default TaskDescriptionView;
